export type ToastTimeout = 'normal' | 'none';
export type ToastType = 'standard' | 'success' | 'warning' | 'error';
export type ToastPriority = 'low' | 'normal' | 'high';
export type ToastActionUiType = 'button' | 'link';

export type ToastAction = {
  text: string;
  uiType?: ToastActionUiType;
  removeToastOnClick?: boolean;
  onClick: () => void;
};

export type ErrorToastDetails = {
  requestId: string;
};

type TypedToastConfig =
  | {
      type: 'error';
      details?: ErrorToastDetails;
    }
  | {
      type?: Exclude<ToastType, 'error'>;
    };

export type ToastConfig = {
  message: string;
  timeout?: ToastTimeout;
  type?: ToastType;
  priority?: ToastPriority;
  action?: ToastAction;
  onCloseClick?: () => void;
  onToastSeen?: () => void;
} & TypedToastConfig;

export type ShowToast = (config: ToastConfig) => { remove: () => void };
